module.exports = __webpack_public_path__ + "static/img/index-banner2.731824b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index-banner2.png
// module id = 5rnp
// module chunks = 1